/**
 * 组件信息
 */
export const info = {
  name: 'xy-tinymce', // 组件名
  type: 'component-base', // 组件类型
  label: '富文本', // 组件label
  icon: 'icon-xy-text', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 80 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  // 文本内容
  content: { type: String, default: 'hello world!' },
  language: { type: String, default: 'en' },
  autoHeight: { type: Boolean, default: false },
  autoWidth: { type: Boolean, default: false },
  wordBreak: { type: String, default: 'break-all' }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-switch', // 表单组件
    label: '高度自适应', // 表单名称
    propKey: 'autoHeight' // 表单model字段名称
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '宽度自适应', // 表单名称
    propKey: 'autoWidth' // 表单model字段名称
  },
  {
    type: 'xy-form-select',
    label: '单词换行',
    propKey: 'wordBreak',
    options: [
      { label: '允许任意断词（break-all）', value: 'break-all' },
      { label: '正常换行（normal）', value: 'normal' },
      { label: '仅允许在空白处换行（keep-all）', value: 'keep-all' },
      { label: '根据内容自动换行（break-word）', value: 'break-word' }
    ],
    isLanguage: true // 是否可多语言配置
  },
  {
    type: 'xy-form-tinymce', // 表单组件
    label: '富文本内容', // 表单名称
    propKey: 'content', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  }
]
